// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-1400 > *:first-child .card > * {
  border: 1px solid var(--surface-100);
  box-shadow: 0 0 1px 0 rgba(212, 154, 32, 0.15), 0 6px 12px 0 rgba(212, 154, 32, 0.15);
}

.overlay .card {
  --hue: 0;
  --saturation: 100%;
  --lightness: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/customer-service/customer-service.component.scss"],"names":[],"mappings":"AACE;EACE,oCAAA;EACA,qFAAA;AAAJ;;AAIA;EACE,QAAA;EACA,kBAAA;EACA,iBAAA;AADF","sourcesContent":[".wrapper-1400 > *:first-child .card {\r\n  > * {\r\n    border: 1px solid var(--surface-100);\r\n    box-shadow: 0 0 1px 0 rgba(#d49a20, 0.15), 0 6px 12px 0 rgba(#d49a20, 0.15);\r\n  }\r\n}\r\n\r\n.overlay .card {\r\n  --hue: 0;\r\n  --saturation: 100%;\r\n  --lightness: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
